// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-504a34b9],.fade-leave-active[data-v-504a34b9]{transition:opacity 1s ease-in-out,transform 1s ease-in-out}.fade-enter-active[data-v-504a34b9]:first-of-type,.fade-leave-active[data-v-504a34b9]:first-of-type{transition-delay:.15s}.fade-enter[data-v-504a34b9],.fade-leave-to[data-v-504a34b9]{opacity:0;transform:translateY(-50px)}", ""]);
// Exports
module.exports = exports;
